import { GROUP_NAME } from '@greenkub-fronts/shared/interface';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const authCallback = createAsyncThunk(
  'authCallback',
  async (
    data,
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    const authCallback = localStorage.getItem('auth-callback') || '';
    localStorage.setItem('auth', authCallback);
    const stored = JSON.parse(authCallback);

    const profileResp = await dispatch(
      extra.apiSlice.endpoints.getProfile.initiate(
        {
          token: stored.token,
          groupName: GROUP_NAME.PROFILE,
        },
        { forceRefetch: true }
      )
    );

    localStorage.removeItem('auth-callback');

    return {
      email: profileResp.data.email,
      token: stored.token,
      profile: profileResp.data,
    };
  }
);

export default authCallback;
